import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Utils from "../../../utils";
import { ADMIN_LOCAL_STORE } from "../../../configs/AppConfig";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdClose } from "react-icons/io";
import Logo from "../../../assets/Images/Docusafe_logo.webp";


function AdminHeader() {
  const navigate = useNavigate();
  const [adminDisplayName, setAdminDisplayName] = useState("");
  const [adminLoginUserName, setAdminLoginUserName] = useState("");
  const [adminLoginUserEmail, setAdminLoginUserEmail] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [showAdminDetails, setShowAdminDetails] = useState(false);

  useEffect(() => {
    setAdminDisplayName(Utils.adminDisplayName());
    let loginData = Utils.adminLoginUserData();
    if (Object.keys(loginData).length > 0) {
      setAdminLoginUserName(loginData.first_name + " " + loginData.last_name);
      setAdminLoginUserEmail(loginData.email);
    }
  }, []);

  const onLogout = () => {
    localStorage.removeItem(ADMIN_LOCAL_STORE);
    navigate("/back-admin/login");
  };

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
    if (showAdminDetails) {
      setShowAdminDetails(false);
    }
  };

  const toggleAdminDetails = () => {
    setShowAdminDetails(!showAdminDetails);
  };

  return (
    <nav className="navbar navbar-expand-lg bg-white shadow-sm fixed-top guest-header admin-header p-0">
      <div className="container">
        <NavLink to="/back-admin" className="navbar-brand">
          <img
            src={Logo}
            alt="DocuSafe Logo"
            className="docusafe_logo"
          />
        </NavLink>

        <button className="navbar-toggler" onClick={toggleNavbar}>
          {isOpen ? (
            <IoMdClose size={24} color="black" className="icon me-0 m-0" />
          ) : (
            <GiHamburgerMenu
              size={24}
              color="black"
              className="icon me-0 m-0"
            />
          )}
        </button>

        <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarContent">
          <ul className="navbar-nav  mb-2 mb-lg-0">
            <li className="nav-item">
              <NavLink
                to="/back-admin/"
                className={({ isActive }) =>
                  `nav-link m-0 ${isActive ? "active" : ""}`
                }
                end
                onClick={toggleNavbar}
              >
                Dashboard
                {/* <span className="badge bg-primary-subtle text-primary ms-1">New</span> */}
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/back-admin/subscribers"
                className={({ isActive }) =>
                  `nav-link m-0 ${isActive ? "active" : ""}`
                }
                onClick={toggleNavbar}
              >
                Subscribers
              </NavLink>
            </li>
            {/* <li className="nav-item">
              <NavLink
                to="/back-admin/plans"
                className={({ isActive }) =>
                  `nav-link m-0 ${isActive ? "active" : ""}`
                }
                onClick={toggleNavbar}
              >
                Plans
              </NavLink>
            </li> */}
            <li className="nav-item">
              <NavLink
                to="/back-admin/2fa"
                className={({ isActive }) =>
                  `nav-link m-0 ${isActive ? "active" : ""}`
                }
                onClick={toggleNavbar}
              >
                2FA
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/back-admin/adminportal"
                className={({ isActive }) =>
                  `nav-link m-0 ${isActive ? "active" : ""}`
                }
                end
                onClick={toggleNavbar}
              >
                Admin
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/back-admin/summary-prompt"
                className={({ isActive }) =>
                  `nav-link m-0 ${isActive ? "active" : ""}`
                }
                onClick={toggleNavbar}
              >
                Summary
                {/* <span className="badge bg-primary-subtle text-primary ms-1">New</span> */}
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/back-admin/files"
                className={({ isActive }) =>
                  `nav-link m-0 ${isActive ? "active" : ""}`
                }
                onClick={toggleNavbar}
              >
                Files
                {/* <span className="badge bg-primary-subtle text-primary ms-1">New</span> */}
              </NavLink>
            </li>
          </ul>
          {isOpen && (
            <div className="d-lg-none border-top pt-3 pb-2">
              <div className="px-3">
                <button
                  className="btn btn-link text-dark text-decoration-none d-flex align-items-center mb-2"
                  onClick={toggleAdminDetails}
                >
                  <span
                    className="d-inline-flex align-items-center justify-content-center bg-secondary-subtle rounded-circle me-2"
                    style={{ width: "30px", height: "30px" }}
                  >
                    {adminDisplayName.charAt(0)}
                  </span>
                  <span>{adminDisplayName}</span>
                </button>
                {showAdminDetails && (
                  <div className="ms-4">
                    <p className="mb-2 fw-medium">DocuSafe.ai Pty Ltd</p>
                    <div className="d-flex align-items-center mb-2">
                      <span
                        className="d-inline-flex align-items-center justify-content-center bg-secondary-subtle rounded-circle me-2"
                        style={{ width: "40px", height: "40px" }}
                      >
                        {adminDisplayName.charAt(0)}
                      </span>
                      <div>
                        <p className="mb-0 fw-medium">{adminLoginUserName}</p>
                        <p className="mb-0 text-muted small">{adminLoginUserEmail}</p>
                        <NavLink
                          to="/back-admin"
                          className="text-primary small text-decoration-underline"
                          onClick={() => {
                            toggleNavbar();
                            setShowAdminDetails(false);
                          }}
                        >
                          Profile
                        </NavLink>
                      </div>
                    </div>
                    <button
                      className="btn btn-link text-dark text-decoration-none"
                      onClick={() => {
                        onLogout();
                        toggleNavbar();
                        setShowAdminDetails(false);
                      }}
                    >
                      Sign Out
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <div>
        <ul className="navbar-nav ms-auto mb-2 mb-lg-0 d-none d-lg-flex">
            <li className="nav-item dropdown">
              <button
                className="nav-link dropdown-toggle bg-light rounded px-3 py-1 text-dark"
                id="userDropdown"
                onClick={toggleAdminDetails}
                aria-expanded={showAdminDetails}
              >
                {adminDisplayName}
              </button>
              <ul
                className={`dropdown-menu dropdown-menu-end ${showAdminDetails ? "show" : ""}`}
                aria-labelledby="userDropdown"
              >
                <li className="dropdown-item-text px-3 py-2">
                  <p className="mb-0 fw-medium">DocuSafe.ai Pty Ltd</p>
                </li>
                <li className="dropdown-item-text px-3 py-2">
                  <div className="d-flex align-items-center">
                    <span
                      className="d-inline-flex align-items-center justify-content-center bg-secondary-subtle rounded-circle me-2"
                      style={{ width: "40px", height: "40px" }}
                    >
                      {adminDisplayName.charAt(0)}
                    </span>
                    <div>
                      <p className="mb-0 fw-medium">{adminLoginUserName}</p>
                      <p className="mb-0 text-muted small">{adminLoginUserEmail}</p>
                      <NavLink
                        to="/back-admin"
                        className="text-primary small text-decoration-underline"
                        onClick={() => {
                          toggleNavbar();
                          setShowAdminDetails(false);
                        }}
                      >
                        Profile
                      </NavLink>
                    </div>
                  </div>
                </li>
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      onLogout();
                      toggleNavbar();
                      setShowAdminDetails(false);
                    }}
                  >
                    Sign Out
                  </button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default AdminHeader;